import { createSlice } from "@reduxjs/toolkit";

export interface UserState {
  user: {
    organizationId: string;
    id?: string;
    tag?: string;
    email?: string;
    accountDetails?: AccountDetails;
    financeDetails?: FinanceDetails;
    settings?: {};
    otp: string[];
    phone: string;
    organization_role_id?: string;
  };
}
export interface AccountDetails {
  accountName?: string;
  accountNumber?: string;
  accountType?: string;
  bankName?: string;
  currency?: string;
  iban?: string;
  id?: string;
  routingNumber?: string;
  sortCode?: null | string; // Assuming it can be null or a string
  status?: string;
  swiftCode?: string;
}

export interface FinanceDetails {
  available?: number;
  balance?: number;
  hold?: number;
}
export const initialState = {
  user: {
    organizationId: "",
    id: "",
    tag: "",
    email: "",
    phone: "",
    accountDetails: {
      accountName: "",
      accountNumber: "",
      accountType: "",
      bankName: "",
      currency: "",
      iban: "",
      id: "",
      routingNumber: "",
      sortCode: null,
      status: "",
      swiftCode: "",
    },
    financeDetails: {
      available: 0,
      balance: 0,
      hold: 0,
    },
    settings: {},
    otp: [],
    organization_role_id: "",
  },
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserData: (state, action) => {
      const {
        organizationId,
        id,
        email,
        tag,
        accountDetails,
        financeDetails,
        settings,
        otp,
        phone,
        organization_role_id,
      } = action.payload;
      state.user.organizationId = organizationId;
      state.user.id = id;
      state.user.email = email;
      state.user.phone = phone;
      state.user.tag = tag;
      state.user.accountDetails = accountDetails;
      state.user.financeDetails = financeDetails;
      state.user.settings = settings;
      state.user.otp = otp;
      state.user.organization_role_id = organization_role_id;
    },
  },
});

export const { setUserData } = userSlice.actions;
export default userSlice.reducer;
